// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"MotorDataHPItems__TitleWrapper___2aqvv","MotorDataHPItems":"MotorDataHPItems__MotorDataHPItems___1LcWk"};